<template>
  <div class="company-page">
    <Navbar></Navbar>
    <!-- 头部banner区域 -->
    <div class="hero-section">
      <div class="container">
        <el-row :gutter="40" type="flex" align="middle">
          <el-col :span="12">
            <div class="hero-content">
              <h1 v-animate="'fadeInLeft'">公司卡適用於成長中的企業</h1>
              <p v-animate="'fadeInLeft'" :style="{ animationDelay: '0.2s' }">
                無限量發出公司卡可讓每位團隊成員都擁有自己的一張卡。並授權他們處理合理支出，同時通過公司卡的開支限額和商戶鎖定功能亦可維持控制權。</p>
              <!-- <el-button type="success" round size="large" v-animate="'fadeInUp'" :style="{ animationDelay: '0.4s' }">
                立即体验
                <i class="el-icon-arrow-right el-icon--right"></i>
              </el-button> -->
            </div>
          </el-col>
          <el-col :span="12">
            <div class="hero-image" v-animate="'fadeInRight'">
              <img src="../assets/gird/1.jpg" alt="移动支付设备">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 后添加合作伙伴展示区域 -->
    <!-- <div class="section partners-section">
      <div class="container">
        <h2 class="section-title animate-on-scroll fade-left">獲得超過50,000間現代企業的信賴</h2>
        <div class="partners-list">
          <img v-for="(partner, index) in partners" :key="index" :src="partner.logo" :alt="partner.name">
        </div>
      </div>
    </div> -->
    <!-- 功能优势展示区域 -->
    <div class="section advantages-section">
      <div class="container">
        <el-row :gutter="60" type="flex" align="middle">
          <el-col :span="10">
            <div class="advantages-content animate-on-scroll fade-left ">
              <h2>使用 TAROM 公司卡提升團隊能力並加快擴展速度</h2>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="advantages-list">
              <div v-for="(advantage, index) in advantages" :key="index" class="advantage-item animate-on-scroll fade-left"
                v-animate="'fadeInRight'" :style="{ animationDelay: `${index * 0.2}s` }">
                <i :class="advantage.icon"></i>
                <div class="advantage-text">
                  <h3>{{ advantage.title }}</h3>
                  <p>{{ advantage.description }}</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 功能特点展示 -->
    <div class="section features-grid">
      <div class="container">
        <h2 class="section-title animate-on-scroll fade-left">TAROM 公司卡的特點和優勢</h2>
        <div class="features-container ">
          <el-row :gutter="40" v-for="(item, index) in gridFeatures" :key="index" class="feature-row animate-on-scroll fade-left">
            <el-col :span="12" :order="index % 2 === 0 ? 1 : 2">
              <div class="feature-image" v-animate="'fadeInLeft'">
                <img :src="item.image" :alt="item.title">
              </div>
            </el-col>
            <el-col :span="12" :order="index % 2 === 0 ? 2 : 1">
              <div class="feature-content" v-animate="'fadeInRight'">
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>


    <div class="section customer-experience">
      <div class="container">
        <h2 class="section-title animate-on-scroll fade-left">客戶的親身體驗分享</h2>
        <div class="experience-tabs">
          <div class="tab-header">
            <span v-for="(tab, index) in testimonials" :key="index"
              :class="['tab-item', { active: currentTab === index }]" @click="currentTab = index">
              {{ tab.company }}
            </span>
          </div>
          <div class="tab-content" v-animate="'fadeIn'">
            <div class="testimonial-card">
              <img :src="testimonials[currentTab].logo" :alt="testimonials[currentTab].company" class="company-logo">
              <div class="rating">
                <i class="el-icon-star-on" v-for="n in 5" :key="n"></i>
              </div>
              <p class="testimonial-text">{{ testimonials[currentTab].content }}</p>
              <div class="metrics">
                <div class="metric">
                  <h3>${{ testimonials[currentTab].savings }}</h3>
                  <p>每年可節省</p>
                </div>
                <div class="metric">
                  <h3>{{ testimonials[currentTab].hours }}小時</h3>
                  <p>每年可節省</p>
                </div>
              </div>
              <!-- <div class="author">
                <img :src="testimonials[currentTab].avatar" :alt="testimonials[currentTab].author">
                <div class="author-info">
                  <h4>{{ testimonials[currentTab].author }}</h4>
                  <p>{{ testimonials[currentTab].position }}</p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="section card-info">
      <div class="container">
        <h2 class="section-title animate-on-scroll fade-left">了解公司卡</h2>
        <el-row :gutter="60" type="flex" align="middle">
          <el-col :span="12">
            <div class="card-image" v-animate="'fadeInLeft'">
              <img src="@/assets/gird/8.jpg" alt="公司卡使用展示">
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-content" v-animate="'fadeInRight'">
              <h3>公司卡如何運作？</h3>
              <p>與個人信用卡或信用卡相比，銀行或其他金融機構（如TAROM）亦可向企業提供公司卡。這些公司卡共有兩種：公司付款公司卡和公司付款個人卡。公司可根據企業和分級員工用於與業務相關的開支。</p>
              <p>
                然而，這些公司卡所產生的費用所由公司承擔。公司卡使用工作以及公司支出，而無需自行支付相關費用。對於企業而言，它確實能夠輕鬆處理、設置卡開支限額、設置卡開支限額，並在全面監控下確保開支。公司卡還能用於多種用途，如保險和企業工作。
              </p>
              <div class="card-question">
                <h3>應向誰發出公司卡？</h3>
                <p>早期時企業會傾向公司卡發放或高級經理發放公司卡。然而，隨著公司規模，不同職級的員工也需要處理支出，因而容易造成開支混亂。</p>
                <p>現代化公司卡發出方法是根據工作需求來發用，某些職位、客戶服務、採購經理、採購團隊，在往來公司卡中用於支付相關的開支。</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>


    <div class="section benefits-section">
      <div class="container">
        <h2 class="section-title animate-on-scroll fade-left">向員工發出公司卡的好處</h2>
        <el-row :gutter="30">
          <el-col :span="8" v-for="(benefit, index) in cardBenefits" :key="index">
            <div class="benefit-card" v-animate="'fadeInUp'" :style="{ animationDelay: `${index * 0.2}s` }">
              <i :class="benefit.icon"></i>
              <h3>{{ benefit.title }}</h3>
              <p>{{ benefit.description }}</p>
            </div>
          </el-col>
        </el-row>

        <div class="card-type-info">
          <h3>為你的業務選擇公司卡</h3>
          <div class="card-types">
            <div class="type-item">
              <h4>虛擬卡還是實體卡？</h4>
              <p>
                在現今的財務生態系統中，你可選用虛擬公司卡和實體公司卡。實體卡是市場上存在多年的普遍實體卡。虛擬卡是電子卡，可存儲在你的手機、平板電腦、手提電腦等設備中，雖然它們的功能與實體卡完全相同，但並不實際存在。獨效性是簡單卡片有其優勢，但隨著科技上交易越來越數碼化，虛擬卡正逐漸取代市場上的實體卡。
              </p>
            </div>
            <div class="type-item">
              <h4>扣賬卡還是信用卡？</h4>
              <p>公司卡既可作扣賬卡，運用賬戶中的資金， 亦可作信用卡，根據你的條件提取指定金額，並在指定期間內償還。信用卡有助確保順暢的現金流，而扣賬卡則適合
                希望控制開支在指定限額內的企業。TAROM公司卡是一張商務扣賬卡，但它有提供靈活信用額度，從而為企業同時提供控制權和額外資金，促進順暢的現金流。</p>
            </div>
            <div class="type-item">
              <h4>公司卡還是業務卡？</h4>
              <p>傳統上，公司卡是為年收入高的大企業設計，而業務卡則是為小型企業設計。隨著時代快速變 遷，越來越多大型或小型公司都優先採用國際化電子方法，與此同時公司卡和業務卡
                則提供越來越多電子優惠。與其根據卡名來作選擇，不如了解每張卡的詳細優惠， 找出哪一張卡更符合你的業務需求。</p>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="section faq-section">
      <div class="container">
        <el-row :gutter="60">
          <el-col :span="10">
            <div class="faq-title">
              <h2>有關 TAROM 公司卡及商務卡的常見問題</h2>
            </div>
          </el-col>
          <el-col :span="14">
            <el-collapse v-model="activeNames" accordion>
              <el-collapse-item name="1">
                <template slot="title">
                  TAROM 商務卡的匯率是多少？
                </template>
                <div class="collapse-content">
                  <p>在 TAROM，我們希望您享受市場上最低的費率。</p>
                  <ul>
                    <li>零卡片啟用費</li>
                    <li>零卡片交易費</li>
                    <li>最佳匯率，比銀行便宜高達 3 倍</li>
                  </ul>
                </div>
              </el-collapse-item>

              <el-collapse-item name="2">
                <template slot="title">
                  如何透過 TAROM 商務卡獲取現金回贈？
                </template>
                <div class="collapse-content">
                  <p>所有 TAROM 卡持卡人在符合條件的消費（線上行銷和 SaaS）上都能享受至少 1% 的現金回饋。我們的現金回饋促銷旨在幫助您的企業蓬勃發展，因此請好好利用它們！</p>
                  <p>現金回饋會根據您的數位行銷和 SaaS 支出，在每月底自動計算。回饋金將於下個月的第一週存入您的企業賬戶。</p>
                  <p>當現金回饋處理完成後，您將收到一封單獨的電子郵件通知。</p>
                </div>
              </el-collapse-item>

              <el-collapse-item name="3">
                <template slot="title">
                  企業可以創建多張商務卡嗎？
                </template>
                <div class="collapse-content">
                  <p>您可以為董事、員工，甚至外部人員（如會計師）創建多張卡片，而無需額外費用。</p>
                  <p>在為個別用戶發行 TAROM 卡時，您還可以為特定的公司支出命名該卡（例如，Facebook 廣告費用）。</p>
                </div>
              </el-collapse-item>

              <el-collapse-item name="4">
                <template slot="title">
                  我該如何將 TAROM 商務卡發行給其他用戶？
                </template>
                <div class="collapse-content">
                  <p>作為管理員，您可以為員工發行帶有消費限額的虛擬卡，且無需額外費用。對於已經在 TAROM 的員工，管理員可以通過以下方式發卡：</p>
                  <ul>
                    <li>點擊「借記卡」以訪問您的公司卡頁面</li>
                    <li>點擊「+ 新卡」按鈕以開始創建卡片</li>
                    <li>選擇您想要為其創建卡片的用戶，並填寫所需字段</li>
                    <li>片會立即創建完成</li>
                  </ul>
                  <p>您可以在邀請流程中發行卡片。請注意，管理員無法向其他帳戶管理員發卡，他們可以自行發行卡片。請注意，帳戶管理員（董事）的卡片在帳戶激活後會自動創建。</p>
                </div>
              </el-collapse-item>

            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </div>




    <!-- 用户评价 -->
    <div class="section contact-section">
      <div class="container">
        <h2 class="section-title">還有疑問嗎？</h2>
        <h3 class="section-subtitle">請跟我們聯繫！</h3>
        <div class="contact-options">
          <!-- <div class="contact-card">
            <i class="el-icon-message"></i>
            <h4>免費開戶</h4>
            <p>立即開始未來的商業金融</p>
            <el-button type="success" plain>立即免費開戶</el-button>
          </div> -->
          <div class="contact-card">
            <i class="el-icon-phone"></i>
            <h4>TAROM CO.,LIMITED</h4>
            <p>聯絡銷售人員</p>
            <p>邮箱：tarom2025@yeah.net</p>
            <!-- <el-button type="primary" plain>跟銷售人員聯絡</el-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 了解更多 -->
    <!-- <div class="section contact">
      <div class="container">
        <h2>了解更多？</h2>
        <div class="contact-buttons">
          <el-button type="primary">联系我们</el-button>
          <el-button type="success">商务合作</el-button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
export default {
  name: 'CompanyCard',
  components: {
    Navbar
  },
  data() {
    return {
      activeNames: ['1'], // 默认展开第一项
      features: [
        { icon: 'el-icon-check', text: '多重安全防护' },
        { icon: 'el-icon-mobile-phone', text: '移动端支付' },
        { icon: 'el-icon-data-analysis', text: '数据分析' },
        { icon: 'el-icon-money', text: '快速结算' }
      ],
      partners: [
        { name: 'Endowus', logo: require('@/assets/partners/endowus.webp') },
        { name: 'Habyt', logo: require('@/assets/partners/habyt.svg') },
        { name: 'Carousel', logo: require('@/assets/partners/carousel.svg') },
        { name: 'Multiplier', logo: require('@/assets/partners/multiplier.png') },
        { name: 'Love Bonito', logo: require('@/assets/partners/love-bonito.svg') },
        { name: 'jpjq', logo: require('@/assets/partners/jpjqsvg.svg') },
        { name: 'F.MMICK', logo: require('@/assets/partners/fmmick.svg') }
      ],
      advantages: [
        {
          icon: 'el-icon-user-solid',
          title: '提供你的團隊',
          description: '可同時向團隊無限發卡，以及令可可用的方式快捷地分發現金。'
        },
        {
          icon: 'el-icon-lock',
          title: '靈活掌控之中',
          description: '每張公司卡都能限制支限額，避免意外的額外支出，讓你放心下來。'
        },
        {
          icon: 'el-icon-document',
          title: '減少文書工作',
          description: '你的團隊可以從手上傳收據，接通現接整合會計系統，你可把時間用於需時間關注的一些。'
        }
      ],
      gridFeatures: [
        {
          title: '可向團隊員工發行無限量的虛擬公司卡',
          description: '無限量虛擬卡讓你可向為每位員工、商戶或案例發卡。告別共享卡或一次性密碼，迎接更快速和安全的消費體驗。',
          image: require('@/assets/gird/2.jpg')
        },
        {
          title: '可實時控制及維持公司卡的消費透明度',
          description: '不再出現超支或高昂的意外支出。設置開支限額、批准政策，並可隨時追蹤消費實況。',
          image: require('@/assets/gird/3.jpg')
        },
        {
          title: '告別追收收據',
          description: '透過自動化的收據提醒和無縫上傳體驗，告別手動追蹤。 在同一地方內隨時翻查並輕鬆搜索所有交易記錄。',
          image: require('@/assets/gird/4.jpg')
        },
        {
          title: '使用多貨幣公司卡節省外匯費用',
          description: '在使用TAROM卡消費時，可利用市場領先的外匯匯率，其價格可低至銀行的三倍。發出TAROM公司卡可以多種貨幣進行交易，並直接使用美元或新加坡元消費即可避免外匯費用。未來將包含更多貨幣。',
          image: require('@/assets/gird/5.webp')
        },
        {
          title: '數碼消費支出賺取現金回贈',
          description: '數碼營銷及SaaS消費可賺取1%現金回贈。',
          image: require('@/assets/gird/6.jpg')
        },
        {
          title: '與你的會計軟件整合',
          description: '將所有交易與主要會計軟件同步，提升結賬速度兩倍。',
          image: require('@/assets/gird/7.webp')
        }
      ],
      currentTab: 0,
      testimonials: [
        {
          company: 'Endowus',
          logo: require('@/assets/gird/1.webp'),
          content: '「作為一家初創企業，我們需要更靈活的解決方案貼合我們不斷增長的需求，提供符合經濟效益的方案支持我們持續成長。」',
          savings: '110,000',
          hours: '900',
          author: 'Gregory Yan',
          position: 'Endowus 行政總裁',
          avatar: require('@/assets/gird/1.webp')
        },
        {
          company: 'Zenyum',
          logo: require('@/assets/gird/1.webp'),
          content: '「TAROM的解決方案幫助我們更好地管理支出，提高了運營效率。」',
          savings: '95,000',
          hours: '800',
          author: 'Julian Tan',
          position: 'Zenyum 財務總監',
          avatar: require('@/assets/gird/1.webp')
        },
        {
          company: 'Multiplier',
          logo: require('@/assets/gird/1.webp'),
          content: '「使用TAROM後，我們的財務流程變得更加順暢，節省了大量時間。」',
          savings: '88,000',
          hours: '750',
          author: 'Sarah Chen',
          position: 'Multiplier 營運總監',
          avatar: require('@/assets/gird/1.webp')
        }
      ],
      cardBenefits: [
        {
          icon: 'el-icon-data-line',
          title: '加速你的業務擴展',
          description: '發出公司卡可有助于你必要的財務流程權限至員工身上，能有效提升企業內部運作效能。另一方面，朝向公司可輕鬆整合公司開支，並將公司卡與其他財務流程無縫整合，如開支管理及會計軟件。藉此協助企業自動化並加速增長。'
        },
        {
          icon: 'el-icon-document-checked',
          title: '減少款許',
          description: '現代公司卡備有多種功能來減少狀況發生，例如交易限額、鎖別限定和在去失或密碼策略的提醒，使分公司卡給員工成為更安全的作法。你也分擔了一份財務責任，讓員工對自己的卡片擁有責任。從而有助於大幅減少款許問題。'
        },
        {
          icon: 'el-icon-view',
          title: '更高透明度',
          description: '現代公司卡提供自動化管理、費用分類等功能，有助於接觸高級明瞭。設過向員工分發卡片，企業可以輕鬆追蹤公司各個層面的所有支出，如團隊整體面向上的支出。'
        }
      ]
    }
  },
  mounted() {
    this.initScrollAnimation();
  },
  methods: {
    initScrollAnimation() {
      const animatedElements = document.querySelectorAll('.animate-on-scroll');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      }, {
        threshold: 0.1
      });

      animatedElements.forEach(element => {
        observer.observe(element);
      });
    }
  }
}
</script>

<style scoped lang="less">
.company-page {
  min-height: 100vh;
  background: linear-gradient(90deg, #ffffff 0%, #e8f6f3 50%, #d1f2eb 100%);
  padding-top: 80px;
}

.features-grid {
  background: linear-gradient(90deg, #f5f6fa 0%, #e8f6f3 100%);
}

.testimonial {
  background: linear-gradient(90deg, #ffffff 0%, #f7f9f9 100%);
}

.contact {
  background: linear-gradient(90deg, #f5f6fa 0%, #e8f6f3 100%);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

hero-section {
  background: linear-gradient(135deg, #1abc9c 0%, #2ecc71 100%);
  padding: 100px 0;
  color: white;
  position: relative;
  overflow: hidden;
}

.hero-content {
  padding-right: 40px;
  text-align: left;
}

.hero-content h1 {
  font-size: 3em;
  margin-bottom: 20px;
  line-height: 1.2;
  font-weight: 600;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 1.4em;
  margin-bottom: 30px;
  opacity: 0.9;
  line-height: 2.1;
}

.hero-content .el-button {
  padding: 15px 30px;
  font-size: 1.1em;
}

.hero-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-image img {
  width: 100%;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.hero-image img:hover {
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .hero-section {
    padding: 60px 0;
  }

  .hero-content {
    padding-right: 0;
    text-align: center;
    margin-bottom: 40px;
  }

  .hero-content h1 {
    font-size: 2.2em;
  }

  .hero-content p {
    font-size: 1.2em;
  }
}

.section {
  padding: 80px 0;
}

.section-title {
  text-align: center;
  font-size: 2em;
  margin-bottom: 40px;
  color: #2c3e50;
}

.features-container {
  margin: 60px 0;
}

.feature-row {
  margin-bottom: 80px;
  display: flex;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
}

.feature-image {
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: auto;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
}

.feature-content {
  padding: 20px 40px;

  h3 {
    font-size: 1.8em;
    color: #2c3e50;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  p {
    font-size: 1.1em;
    color: #666;
    line-height: 1.8;
  }
}

@media (max-width: 768px) {
  .feature-row {
    margin-bottom: 40px;
  }

  .feature-content {
    padding: 20px 0;
    text-align: center;

    h3 {
      font-size: 1.5em;
    }
  }

  .feature-image {
    margin-bottom: 20px;
  }
}


.feature-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 40px 0;
}

.feature-item {
  display: flex;
  align-items: center;
  margin: 10px 20px;
}

.feature-item i {
  font-size: 24px;
  color: #2ecc71;
  margin-right: 10px;
}

.features-grid {
  background: #f8f9fa;
}

.feature-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  transition: transform 0.3s;
}

.feature-card:hover {
  transform: translateY(-10px);
}

.feature-card img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.feature-card h3 {
  padding: 20px 20px 10px;
  font-size: 1.3em;
}

.feature-card p {
  padding: 0 20px 20px;
  color: #666;
}

.testimonial {
  background: white;
  text-align: center;
}

.testimonial-content {
  max-width: 800px;
  margin: 0 auto;
}

.testimonial img {
  width: 120px;
  margin-bottom: 20px;
}

.stars {
  color: #f1c40f;
  font-size: 24px;
  margin: 20px 0;
}

.quote {
  font-size: 1.4em;
  color: #2c3e50;
  margin: 20px 0;
}

.author {
  color: #666;
}

.contact {
  background: #f8f9fa;
  text-align: center;
}

.contact-buttons {
  margin-top: 30px;
}

.contact-buttons .el-button {
  margin: 0 10px;
}

@media (max-width: 768px) {
  .hero-content {
    text-align: center;
  }

  .feature-list {
    flex-direction: column;
    align-items: center;
  }

  .feature-item {
    margin: 10px 0;
  }
}


.partners-section {
  padding: 60px 0;
  background: #fff;
  margin-top: 50px;
}

.partners-list {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 40px;
}

.partners-list img {
  height: 30px;
  object-fit: contain;
  opacity: 0.6;
  transition: opacity 0.3s;
}

.partners-list img:hover {
  opacity: 1;
}

.advantages-section {
  padding: 100px 0;
  background: #fff;
}

.advantages-content {
  h2 {
    font-size: 2.5em;
    line-height: 1.4;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0;
  }
}

.advantages-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.advantage-item {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(10px);
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.advantage-text {
  text-align: left;
}

@media (max-width: 768px) {
  .advantages-content h2 {
    font-size: 2em;
    text-align: center;
    margin-bottom: 40px;
  }

  .advantage-item {
    margin: 0 20px;

    &:hover {
      transform: translateY(-5px);
    }
  }
}




.customer-experience {
  background: #fff;
  padding: 100px 0;
}

.experience-tabs {
  max-width: 900px;
  margin: 0 auto;
}

.tab-header {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 40px;
}

.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  position: relative;
  color: #666;
  transition: all 0.3s ease;

  &.active {
    color: #00b894;
    font-weight: 600;

    &:after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 2px;
      background: #00b894;
    }
  }
}

.testimonial-card {
  text-align: center;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.company-logo {
  height: 40px;
  margin-bottom: 20px;
}

.rating {
  color: #f1c40f;
  font-size: 24px;
  margin: 20px 0;
}

.testimonial-text {
  font-size: 1.4em;
  line-height: 1.6;
  color: #2c3e50;
  margin: 30px 0;
}

.metrics {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  margin: 40px 0;
}

.metric {
  h3 {
    font-size: 2em;
    color: #00b894;
    margin-bottom: 10px;
  }

  p {
    color: #666;
  }
}

.author {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  .author-info {
    text-align: left;

    h4 {
      font-size: 1.1em;
      color: #2c3e50;
      margin-bottom: 5px;
    }

    p {
      color: #666;
      font-size: 0.9em;
    }
  }
}

@media (max-width: 768px) {
  .tab-header {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .metrics {
    flex-direction: column;
    gap: 30px;
  }

  .testimonial-text {
    font-size: 1.2em;
  }
}


.card-info {
  background: #fff;
  padding: 100px 0;
}

.card-image {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.card-content {
  h3 {
    font-size: 2em;
    color: #2c3e50;
    margin-bottom: 24px;
    line-height: 1.4;
  }

  p {
    font-size: 1.1em;
    color: #666;
    line-height: 1.8;
    margin-bottom: 20px;
  }
}

.card-question {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid #eee;
}

@media (max-width: 768px) {
  .card-content {
    text-align: center;
    margin-top: 40px;

    h3 {
      font-size: 1.8em;
    }
  }

  .card-question {
    margin-top: 30px;
    padding-top: 30px;
  }
}


.benefits-section {
  background: #fff;
  padding: 100px 0;
}

.benefit-card {
  padding: 40px;
  background: #f8f9fa;
  border-radius: 16px;
  height: 100%;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 36px;
    color: #00b894;
    margin-bottom: 20px;
  }

  h3 {
    font-size: 1.5em;
    color: #2c3e50;
    margin-bottom: 20px;
  }

  p {
    color: #666;
    line-height: 1.8;
  }
}

.card-type-info {
  margin-top: 80px;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 16px;

  h3 {
    font-size: 2em;
    color: #2c3e50;
    margin-bottom: 40px;
    text-align: center;
  }
}

.card-types {
  .type-item {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }

    h4 {
      font-size: 1.3em;
      color: #2c3e50;
      margin-bottom: 20px;
    }

    p {
      color: #666;
      line-height: 1.8;
    }
  }
}

@media (max-width: 768px) {
  .benefit-card {
    margin-bottom: 30px;
    text-align: center;
  }

  .card-type-info {
    margin-top: 60px;
    padding: 30px;

    h3 {
      font-size: 1.8em;
    }
  }
}


.faq-section {
  background: #fff;
  padding: 100px 0;
}

.faq-title {
  text-align: left;

  h2 {
    font-size: 2.5em;
    line-height: 1.4;
    color: #2c3e50;
    margin-bottom: 30px;
  }
}

.collapse-content {
  padding: 20px 0;
  color: #666;
  line-height: 1.8;
  text-align: left;

  ul {
    margin-top: 10px;
    padding-left: 20px;

    li {
      margin-bottom: 10px;
      list-style: disc;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

/deep/ .el-collapse {
  border: none;

  .el-collapse-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-collapse-item__header {
      font-size: 1.2em;
      color: #2c3e50;
      border: none;
      background: #f8f9fa;
      padding: 20px;
      border-radius: 8px;

      &.is-active {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      i {
        margin-left: auto;
        transition: transform 0.3s;
      }
    }

    .el-collapse-item__wrap {
      border: none;
      background: #f8f9fa;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;

      .el-collapse-item__content {
        padding: 0 20px 20px;
      }
    }

    &.is-active {
      .el-collapse-item__header i {
        transform: rotate(90deg);
      }
    }
  }
}

@media (max-width: 768px) {
  .faq-title {
    text-align: center;
    margin-bottom: 40px;

    h2 {
      font-size: 2em;
    }
  }
}


.contact-section {
  background: linear-gradient(90deg, #f5f6fa 0%, #e8f6f3 100%);
  padding: 100px 0;
  text-align: center;

  .section-subtitle {
    color: #666;
    font-size: 1.5em;
    margin-bottom: 60px;
  }

  .contact-options {
    display: flex;
    justify-content: center;
    gap: 40px;
    max-width: 900px;
    margin: 0 auto;
  }

  .contact-card {
    flex: 1;
    padding: 40px;
    background: #f8f9fa;
    border-radius: 16px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }

    i {
      font-size: 36px;
      color: #00b894;
      margin-bottom: 20px;
    }

    h4 {
      font-size: 1.3em;
      color: #2c3e50;
      margin-bottom: 30px;
    }

    p {
      color: #666;
      // margin-bottom: 30px;
      min-height: 33px;
    }

    .el-button {
      padding: 12px 30px;
      font-size: 1.1em;
    }
  }
}

@media (max-width: 768px) {
  .contact-section {
    .contact-options {
      flex-direction: column;
      padding: 0 20px;
    }

    .contact-card {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        min-height: auto;
      }
    }
  }
}

// 添加新的动画样式
.animate-on-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease-out;

  &.animate {
    opacity: 1;
    transform: translateY(0);
  }

  &.fade-up {
    transform: translateY(30px);
  }

  &.fade-down {
    transform: translateY(-30px);
  }

  &.fade-left {
    transform: translateX(-30px);
  }

  &.fade-right {
    transform: translateX(30px);
  }

  &.fade-in {
    transform: translateY(0);
    opacity: 0;
  }
}

// 添加动画延迟类
.delay-1 {
  animation-delay: 0.2s;
}

.delay-2 {
  animation-delay: 0.4s;
}

.delay-3 {
  animation-delay: 0.6s;
}

// 优化现有动画过渡
.feature-row,
.benefit-card,
.testimonial-card,
.contact-card {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

// 添加渐变背景过渡
.section {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: inherit;
    transition: opacity 0.3s ease;
    opacity: 0;
  }

  &.animate {
    &::before {
      opacity: 1;
    }
  }
}

// 优化响应式动画
@media (max-width: 768px) {
  .animate-on-scroll {
    transform: translateY(20px);
  }
}

// 添加内容块hover效果增强
.feature-content,
.card-content,
.benefit-card {
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  }
}

// 优化过渡时间
* {
  transition-duration: 0.3s;
}
</style>